(() => {
  // app/scripts/slider-component.js
  if (!customElements.get("slider-component")) {
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.sliderContainer = this.querySelector(".js-slider-container");
        this.config = Object.assign(JSON.parse(this.querySelector("[data-tns-config]").innerHTML), {
          onInit: (info) => {
            this.modifyNavItemsTabindex(info);
            this.modifySlideTabindex(info);
            this.modifyControlButtonsDisabled(info);
            this.makeSVGUniq();
            this.addEventListener("mouseover", this.mouseOverHandling.bind(this));
            this.addEventListener("mouseleave", this.mouseLeaveHandling.bind(this));
            this.addEventListener("focusin", this.focusInHandling.bind(this));
            this.addEventListener("focusout", this.focusOutHandling.bind(this));
            this.sliderContainer.classList.add("slider-initialized");
            this.dispatchEvent(new CustomEvent("slider::initialized", { bubbles: true }));
          }
        });
        if (this.getAttribute("data-init-type") === null || this.getAttribute("data-init-type") === "auto") {
          this.observer = new IntersectionObserver((entries, observer) => {
            if (!entries[0].isIntersecting)
              return;
            observer.unobserve(this);
            this.isIntersecting = true;
            this.init();
          }, { rootMargin: "200px 0px 200px 0px" });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        if (!this.isIntersecting)
          this.observer?.unobserve(this);
        this.destroy();
      }
      init(config = {}) {
        try {
          this.slider = tns(Object.assign({ ...this.config }, config));
          this.slider.events.on("transitionStart", (info) => {
            this.modifyNavItemsTabindex(info);
            this.modifySlideTabindex(info);
            this.modifyControlButtonsDisabled(info);
          });
          return this.slider;
        } catch (error) {
          console.log("slider::error", this);
          console.error("error::", error);
        }
      }
      makeSVGUniq() {
        const SVGs = this.querySelectorAll("svg.placeholder-svg");
        if (SVGs.length > 1) {
          SVGs.forEach((svg, index) => {
            this.updateClipPath(svg, index);
          });
        }
      }
      updateClipPath(svgElement, index) {
        const elementsWithClipPath = svgElement.querySelectorAll("[clip-path]");
        elementsWithClipPath.forEach((element) => {
          const clipPathValue = element.getAttribute("clip-path");
          if (clipPathValue && clipPathValue.includes("url(#")) {
            const currentId = clipPathValue.match(/url\(#(.+?)\)/)[1];
            const newClipPathId = currentId + "_js_" + index + this.config.container.replace("#", "_");
            const newClipPathValue = `url(#${newClipPathId})`;
            element.setAttribute("clip-path", newClipPathValue);
            const clipPathElement = svgElement.querySelector(`#${currentId}`);
            if (clipPathElement) {
              clipPathElement.setAttribute("id", newClipPathId);
            }
          }
        });
      }
      modifyNavItemsTabindex(info) {
        if (!info.navItems)
          return;
        for (const [key, value] of Object.entries(info.navItems)) {
          value.setAttribute("tabindex", value.getAttribute("aria-hidden") === "true" ? -1 : 0);
        }
      }
      modifySlideTabindex(info) {
        if (!info.slideItems)
          return;
        for (const [key, value] of Object.entries(info.slideItems)) {
          const linkElements = value.querySelectorAll("a, button");
          if (value.getAttribute("aria-hidden") === "true") {
            if (linkElements.length) {
              linkElements.forEach((button) => {
                button.setAttribute("tabindex", "-1");
              });
            }
          } else {
            if (linkElements.length) {
              linkElements.forEach((button) => {
                if (button.getAttribute("aria-hidden") !== "true") {
                  button.removeAttribute("tabindex");
                }
              });
            }
          }
        }
      }
      modifyControlButtonsDisabled(info) {
        if (info.controlsContainer) {
          info.controlsContainer.setAttribute("tabindex", -1);
          info.controlsContainer.removeAttribute("aria-label");
        }
        if (info.prevButton) {
          info.prevButton.removeAttribute("tabindex");
        }
        if (info.nextButton) {
          info.nextButton.removeAttribute("tabindex");
        }
      }
      mouseOverHandling(e) {
        if (this.config && this.config.autoplay && this.slider) {
          const container = this.getInfo().container;
          container.setAttribute("aria-live", "polite");
          this.pause();
        }
      }
      mouseLeaveHandling(e) {
        if (this.config && this.config.autoplay && this.slider) {
          const container = this.getInfo().container;
          container.setAttribute("aria-live", "off");
          this.play();
        }
      }
      focusInHandling(e) {
        if (this.config && this.config.autoplay && this.slider) {
          const container = this.getInfo().container;
          container.setAttribute("aria-live", "polite");
          this.pause();
        }
      }
      focusOutHandling(e) {
        if (this.config && this.config.autoplay && this.slider) {
          const container = this.getInfo().container;
          container.setAttribute("aria-live", "off");
          this.play();
        }
      }
      destroy() {
        try {
          this.slider?.destroy();
        } catch (error) {
          console.log(this);
          console.warn(error);
        }
      }
      goTo(index) {
        try {
          this.slider.goTo(index);
        } catch (error) {
          console.log(this);
          console.warn(error);
        }
      }
      play() {
        try {
          this.slider.play();
        } catch (error) {
          console.log(this);
          console.warn(error);
        }
      }
      pause() {
        try {
          this.slider.pause();
        } catch (error) {
          console.log(this);
          console.warn(error);
        }
      }
      getConfig() {
        return this.config;
      }
      getInfo() {
        return this.slider?.getInfo();
      }
      isSliderInitialized() {
        return this.sliderContainer.classList.contains("slider-initialized");
      }
    }
    customElements.define("slider-component", SliderComponent);
    document.addEventListener("shopify:block:select", (event) => {
      const target = event.target;
      if (!target)
        return;
      const slide = target.closest(".slider-item");
      if (!slide)
        return;
      const sliderComponent = slide.closest("slider-component");
      if (!sliderComponent || !sliderComponent.slider)
        return;
      const info = sliderComponent.slider.getInfo();
      const slides = Array.from(info.slideItems);
      const index = slides.indexOf(slide);
      if (index > -1) {
        sliderComponent.slider.goTo(index);
      }
    });
  }
})();
